import * as Logger from "./libs/wa-logger"
// import item_summary_click from "item-summary-click"; // eslint-disable-line no-unused-vars
import * as MainMenu from "./controllers/main-menu"
import * as EqualHeight from "./controllers/equal-height"
import * as PostSummaryEvents from "./controllers/post-summary"
import leftMenu from "./controllers/left-menu.js"
import Gallery from "./controllers/gallery.js"
import Banner from "./controllers/banner"
import Vehicle from "./controllers/vehicle.js"
import * as Mapv2 from "./controllers/mapv2"
import notImplemented from "./controllers/not-implemented"
import * as OnBigSmall from "./components/on-screen-big-small.js"

const $ = require("jquery")
// const bs = require("bootstrap") // eslint-disable-line no-unused-vars

Logger.enable()
Logger.log(" initializing behaviors")
Logger.disable()

/*
class App {
  initialize() {}

  onDocReady() {
    Logger.log(" dom ready")
    EqualHeight.initialize(".eq-col")
    Banner("#banner")
    Gallery(".gallery.thumbnails")
    Vehicle()
    MainMenu.initialize()
    OnBigSmall.start()
    this.vehicleLeftMenu = leftMenu.vehicleMenu()
    this.campingLeftMenu = leftMenu.campingMenu()
    this.howLeftMenu = leftMenu.howMenu()
    this.archiveLeftMenus = leftMenu.archiveMenu()
    PostSummaryEvents.initialize()
    notImplemented.initialize()
    mapBehavior.initialize()
  }

//   onWindowLoad() {
//     Logger.log("window ready")
//     EqualHeight.initialize(".eq-col")
//   }
}
window.app = new App()

// $(window).on("load", () => {
//   Logger.log("window ready")
//   window.app.onWindowLoad()
// })

// $(document).ready(() => {
//   window.app.onDocReady()
// })
*/
async function waitHere(duration_ms, msg) {
    return new Promise((resolve, reject) => {
        setTimeout(() => {
            resolve(msg)
        }, duration_ms)
    })
}
async function waitHereForever() {
    while(true) {
        const m = await waitHere(10000, "This is the first wait")
        console.log(m)
        const m2 = await waitHere(10000, "This is the second wait")
        console.log(m2)
    }
}
(async() => {
    const x = await getStarted()
    console.log("after getStarted")
    // const y = await waitHereForever()
})()
/**
 * When the dom is ready - fire off the javascript
 */
async function getStarted() {
    return new Promise((resolve, reject) => {
        $(function(){
            Logger.log(" dom ready")
            Banner("#banner")
            const logo = $("#australia-logo > img")
            if(logo.length >= 1) {
                setTimeout(() => {
                    logo.show()
                    EqualHeight.initialize(".eq-col")
                }, 3000)
            }
            Gallery(".gallery.thumbnails")
            Vehicle()
            MainMenu.initialize()
            EqualHeight.initialize(".eq-col")
            // OnBigSmall.start()
            // MainMenu.initialize()
            this.vehicleLeftMenu = leftMenu.vehicleMenu()
            this.campingLeftMenu = leftMenu.campingMenu()
            this.howLeftMenu = leftMenu.howMenu()
            this.archiveLeftMenus = leftMenu.archiveMenu()
            PostSummaryEvents.initialize()
            // notImplemented.initialize()
            // mapBehavior.initialize()
            Mapv2.map_init()
            resolve({})
        })
    })
}
